<template>
  <v-layout row wrap class="ch-search-filter-wrapper">
    <v-flex xs12 class="ch-search-filter pb-0 pt-0">
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-container fluid grid-list-lg class="pt-0 pb-0">
          <v-layout row wrap class="filter-wrap">
            <button class="form-clear-btn" @click.prevent="clearAllField">
              <i class="fas fa-eraser"></i>
              <span>CLEAR</span>
            </button>
            <v-flex xs2 class="pl-0 pr-0">
              <v-select
                :items="filterUserTypeItems"
                item-text="text"
                item-value="value"
                v-model="filterUserTypeInput"
                label="Type"
                bottom
                single-line
                hide-details
                content-class="input-readonly"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs2 class="pl-0 pr-0">
              <v-text-field
                v-model="filterRoomName"
                label="Room"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs2 class="pl-0 pr-0">
              <v-text-field
                v-model="filterUserEmail"
                label="User Email"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs2 class="pl-0 pr-0">
              <v-text-field
                v-model="filterUserName"
                label="User Name"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs2 class="pl-0 pr-0">
              <v-select
                :items="filterStatusItems"
                item-text="text"
                item-value="value"
                v-model="filterStatusInput"
                label="Status"
                bottom
                single-line
                hide-details
                content-class="input-readonly"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs2 class="pl-0 pr-0" v-if="!hotelsBookingId">
              <v-select
                :items="filterHotelItems"
                v-model="filterHotelInput"
                label="Hotel"
                bottom
                @focus.native="getHotelList"
                @click.native="getHotelList"
                autocomplete
                single-line
                hide-details
                clearable
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
  import _ from 'lodash';
  import { storeFilterEventBus } from '@/components/customized-components/storeFilterEventBus';
  import { bookingsEventBus } from '@/components/admin/bookings/bookingsEventBus';
  import api from '../../../api';

  export default {
    props: ['hotelsBookingId', 'storeFilter'],
    data() {
      return {
        // NOTE: 모든 검색어
        allSearch: {
          hotel: {
            search: null,
            searchCategory: 'hotel_id',
          },
          status: {
            search: null,
            searchCategory: 'status',
          },
          userName: {
            search: null,
            searchCategory: 'user_name',
          },
          userEmail: {
            search: null,
            searchCategory: 'user_email',
          },
          roomName: {
            search: null,
            searchCategory: 'room_name',
          },
          userType: {
            search: null,
            searchCategory: 'user_type',
          },
        },
        valid: true,
        // NOTE: 렌더링 될 변수들
        filterHotel: null,
        filterHotelItems: [],
        filterUserType: null,
        filterUserTypeItems: [
          { text: 'Normal', value: 'normal' },
          { text: 'Anony', value: 'anony' },
        ],
        filterStatus: null,
        filterStatusItems: [
          { text: 'Not assigned', value: 'created' },
          { text: 'Assigned', value: 'issued' },
          { text: 'Canceled', value: 'canceled' },
        ],
        filterUserName: null,
        filterUserEmail: null,
        filterRoomName: null,
      };
    },
    methods: {
      /**
       * @description 상세 => 목록으로 넘어올 경우 필터값을 유지, 컴포넌트가 렌더링될 때 최초 한번만 실행
       */
      init() {
        if (!_.isEmpty(this.storeFilter)) {
          console.log('this.storeFilter not empty');
          const filter = Object.values(this.storeFilter).filter(item => item.search !== null);
          const arr = Object.keys(this.allSearch);
          for (let i = 0; i < arr.length; i += 1) {
            for (let j = 0; j < filter.length; j += 1) {
              if (this.allSearch[arr[i]].searchCategory === filter[j].searchCategory) {
                this.allSearch[arr[i]].search = filter[j].search;
                switch (this.allSearch[arr[i]].searchCategory) {
                  case 'hotel_id':
                    this.filterHotel = filter[j].search;
                    this.getHotelList();
                    break;
                  case 'status':
                    this.filterStatus = filter[j].search;
                    break;
                  case 'user_name':
                    this.filterUserName = filter[j].search;
                    break;
                  case 'user_email':
                    this.filterUserEmail = filter[j].search;
                    break;
                  case 'room_name':
                    this.filterRoomName = filter[j].search;
                    break;
                  case 'user_type':
                    this.filterUserType = filter[j].search;
                    break;
                  default:
                    break;
                }
              }
            }
          }
          this.$nextTick(() => {
            console.log('this.$nextTick');
            bookingsEventBus.$emit('initFilter', this.allSearch);
          });
        }
      },
      clearAllField() {
        this.$refs.form.reset();
      },
      getHotelList() {
        const query = {
          limit: 1000,
        };
        api.getHotelList(query)
        .then((result) => {
          if (result.status === 200) {
            this.filterHotelItems = result.data.map((obj) => {
              const newObj = {};
              newObj.value = obj.id;
              newObj.text = obj.name;
              return newObj;
            });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      /**
       * @description 사용자가 입력을 기다리는 시간(밀리세컨드) 입니다.
       * @param { Object } object, this.allSearch
       * @param { String } routeName
       */
      getInputValue: _.debounce((obj, routeName) => {
        console.log(`routeName: ${routeName}`);
        bookingsEventBus.$emit('customFilter', obj);
        if (routeName !== 'hotelsBookings') storeFilterEventBus.$emit('setFilter', obj);
      }, 100),
    },
    computed: {
      filterHotelInput: {
        get() {
          return this.filterHotel;
        },
        set(newValue) {
          this.filterHotel = newValue;
          this.allSearch.hotel.search = newValue;
          bookingsEventBus.$emit('customFilter', this.allSearch);
          if (this.$route.name !== 'hotelsBookings') storeFilterEventBus.$emit('setFilter', this.allSearch);
        },
      },
      filterStatusInput: {
        get() {
          return this.filterStatus;
        },
        set(newValue) {
          this.filterStatus = newValue;
          this.allSearch.status.search = newValue;
          bookingsEventBus.$emit('customFilter', this.allSearch);
          if (this.$route.name !== 'hotelsBookings') storeFilterEventBus.$emit('setFilter', this.allSearch);
        },
      },
      filterUserTypeInput: {
        get() {
          return this.filterUserType;
        },
        set(newValue) {
          this.filterUserType = newValue;
          this.allSearch.userType.search = newValue;
          bookingsEventBus.$emit('customFilter', this.allSearch);
          if (this.$route.name !== 'hotelsBookings') storeFilterEventBus.$emit('setFilter', this.allSearch);
        },
      },
    },
    watch: {
      /**
       * @description 작업을 실행할 수 있는 빈도를 제한합니다
       */
      filterUserName(newValue) {
        this.allSearch.userName.search = newValue;
        this.getInputValue(this.allSearch, this.$route.name);
      },
      filterUserEmail(newValue) {
        this.allSearch.userEmail.search = newValue;
        this.getInputValue(this.allSearch, this.$route.name);
      },
      filterRoomName(newValue) {
        this.allSearch.roomName.search = newValue;
        this.getInputValue(this.allSearch, this.$route.name);
      },
    },
    mounted() {
      this.init();
    },
    beforeDestroy() {
      bookingsEventBus.$off('initFilter');
      bookingsEventBus.$off('customFilter');
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/bookings/BookingsFilter.vue